import client from "../modules/client";
import HelperService from "./helper-service";

export const login = async ({ login, password }) => {
  return client('/api/v0/login', { body: { type: 'SWEATMOTION', email: login, password: await HelperService.sha512(password) } }).then(({ data }) => data?.profile);
};

export const loginFB = async ({ token }) => {
  return client('/api/v0/login', { body: { type: 'FACEBOOK', token: token } }).then(({ data }) => data?.profile);
};

export const loginAPPLE = async ({ token, name, surname, email }) => {
  return client('/api/v0/login', { body: { type: 'APPLE', token: token, name: name, surname: surname, email: email } }).then(({ data }) => data?.profile);
};

export const signup = async ({ name, surname, email, mobile, password }) => {
  return client('/api/v0/users', { body: { type: 'SWEATMOTION', name: name, surname: surname, email: email, password: await HelperService.sha512(password) } }).then(({ data }) => data?.profile);
};
export const forgotPassword = ({ login }) => {
  return client('/api/v0/password', { body: { email: login } }).then(({ data }) => data);
};

export const resendEmailConfirmation = ( {email} ) => {
  return client('/api/v0/users/resendEmailConfirmation', { body: { email: email } }).then(({ data }) => data);
};

export const logout = () => {
  return Promise.resolve();
};

export const getUserProfile = (userID) => {
  return client(`/api/v0/users/${userID}`).then(({ data }) => data.profile).catch(()=>null);
};

export const deleteUser = () => {
  return client(`/api/v0/users`, {method: 'delete'}).then(({ data }) => data);
};

export const changePassword = async (pass, newPass) => {
  return client(`/api/v0/password`, { method: 'put', body: { actualPassword: await HelperService.sha512(pass), newPassword: await HelperService.sha512(newPass) } }).then(({ data }) => data);
};

export function useAuthService () {
  return {
    login,
    forgotPassword,
    logout,
    getUserProfile,
    deleteUser,
    changePassword,
  };
}
